export const VARIANT_ID_LEFT_KEY_NAME = 'variantIdL'
export const VARIANT_ID_RIGHT_KEY_NAME = 'variantIdR'
export const QUANTITY_LEFT_KEY_NAME = 'quantityL'
export const QUANTITY_RIGHT_KEY_NAME = 'quantityR'
export const QUANTITY_LEFT_DEFAULT_VALUE = 1
export const QUANTITY_RIGHT_DEFAULT_VALUE = 0
